import { render } from "./TheJInputScreen.vue?vue&type=template&id=620b3c76&scoped=true&ts=true"
import script from "./TheJInputScreen.vue?vue&type=script&lang=ts"
export * from "./TheJInputScreen.vue?vue&type=script&lang=ts"

import "./TheJInputScreen.vue?vue&type=style&index=0&id=620b3c76&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620b3c76"]])

export default __exports__